import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getAgencyMapping = async () => {
  const data = await axios.get(`${api_base_url}/AgencyMapping/AgencyMapping`);
  return data;
};

export const deleteAgencyMapping = async (ids) => {
  await axios.delete(`${api_base_url}/AgencyMapping`, {
    data: ids,
  });
};

// Insert New Agency Mapping
export const addAgencyMapping = async (newAgencyMapping) => {
  newAgencyMapping.isActive = !newAgencyMapping.isActive;
  return axios.post(`${api_base_url}/AgencyMapping`, {
    ...newAgencyMapping,
  });
};
//Edit Business License & Permit
export const updateAgencyMapping = async (editAgencyMapping) => {
  const formData = new FormData();
  editAgencyMapping.agencyMappingId &&
    formData.append("agencyMappingId", editAgencyMapping.agencyMappingId);
  editAgencyMapping.agencyName &&
    formData.append("agencyName", editAgencyMapping.agencyName);
  editAgencyMapping.agencySource &&
    formData.append("agencySource", editAgencyMapping.agencySource);
  editAgencyMapping.agencyStandard &&
    formData.append("agencyStandard", editAgencyMapping.agencyStandard);
  editAgencyMapping.state && formData.append("state", editAgencyMapping.state);
  editAgencyMapping.createdBy &&
    formData.append("createdBy", editAgencyMapping.createdBy);
  editAgencyMapping.createdOn &&
    formData.append("createdOn", editAgencyMapping.createdOn);
  editAgencyMapping.isActive !== null &&
    formData.append("isActive", editAgencyMapping.isActive);
  return axios.put(
    `${api_base_url}/AgencyMapping/${editAgencyMapping.agencyMappingId}`,
    formData
  );
};
